/* Consent on Shopify's Customer Privacy API. */
import { $, $$, toast } from '@theme/utils';

const bar = $('[data-consent-bar]');
const root = document.documentElement;
let api = null;

function loadApi() {
  return new Promise((resolve) => {
    if (window.Shopify && window.Shopify.customerPrivacy) { api = window.Shopify.customerPrivacy; resolve(api); return; }
    if (!window.Shopify || !window.Shopify.loadFeatures) { resolve(null); return; }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) { resolve(null); return; }
      api = window.Shopify.customerPrivacy; resolve(api);
    });
  });
}

/* On phones the notice sits above the sticky add-to-cart bar while that bar shows: --cb-lift is the bar's height,
   --cb-top the notice's top edge, which the launcher keeps clear of. On a desk both stay at the notice's own size. */
function stickyBar() { return $$('.sticky').find((el) => getComputedStyle(el).display !== 'none') || null; }
function place() {
  if (!bar || !bar.isConnected) { root.style.removeProperty('--cb-lift'); root.style.removeProperty('--cb-top'); return; }
  const st = window.innerWidth < 900 ? stickyBar() : null;
  const lift = st ? st.offsetHeight : 0;
  bar.classList.toggle('lifted', lift > 0);
  root.style.setProperty('--cb-lift', lift + 'px');
  root.style.setProperty('--cb-top', (lift + (bar.classList.contains('show') ? bar.offsetHeight : 0)) + 'px');
}
let watching = false;
function watch() {
  if (watching) return; watching = true;
  addEventListener('resize', place);
  if ('MutationObserver' in window) {
    const mo = new MutationObserver(place);
    $$('.sticky').forEach((el) => mo.observe(el, { attributes: true, attributeFilter: ['style', 'hidden', 'class'] }));
  }
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(place);
    ro.observe(bar); $$('.sticky').forEach((el) => ro.observe(el));
  }
}

function show() {
  if (!bar || bar.classList.contains('show')) return;
  bar.classList.add('show');
  watch(); place();
  document.dispatchEvent(new CustomEvent('nocry:consent:shown'));
}
function hide() {
  if (!bar) return;
  bar.classList.remove('show');
  setTimeout(() => { bar.remove(); place(); }, 10);
  document.dispatchEvent(new CustomEvent('nocry:consent:shown'));
}

function consentFor(all) { return { analytics: all, marketing: all, preferences: all, sale_of_data: all }; }
function remember(all) { try { localStorage.setItem('nocry-consent', all ? 'all' : 'essential'); } catch (e) { /* no-op */ } }
function remembered() { try { return localStorage.getItem('nocry-consent'); } catch (e) { return null; } }

function setConsent(all) {
  remember(all);
  if (api && api.setTrackingConsent) {
    try { api.setTrackingConsent(consentFor(all), () => hide()); } catch (e) { hide(); }
  } else hide();
}

/* Has this visitor already chosen? shouldShowBanner() only says the region wants a notice; it does not say whether the
   visitor has answered it (17 October: the notice came back on every page). Shopify's own banner gates on the same
   two things: the region flag, and marketing, analytics and preferences all still unset in the visitor's consent. */
function decided(p) {
  try {
    const cv = p && p.currentVisitorConsent ? p.currentVisitorConsent() : null;
    if (cv && (cv.marketing !== '' || cv.analytics !== '' || cv.preferences !== '')) return true;
  } catch (e) { /* no-op */ }
  return false;
}

(async () => {
  const p = await loadApi();
  const preview = bar && bar.dataset.preview === 'true';
  const wanted = !!(p && p.shouldShowBanner && p.shouldShowBanner());
  let done = decided(p);
  if (!done && wanted) {
    /* chosen here before, but Shopify holds no record of it (the save failed, or the cookie went): send the choice again, quietly */
    const mem = remembered();
    if (mem === 'all' || mem === 'essential') {
      if (p.setTrackingConsent) { try { p.setTrackingConsent(consentFor(mem === 'all'), () => {}); } catch (e) { /* no-op */ } }
      done = true;
    }
  }
  const needed = preview || (wanted && !done);
  if (bar && needed) {
    let shown = false;
    const onScroll = () => { if (shown) return; if (window.scrollY > 80) { shown = true; show(); removeEventListener('scroll', onScroll); } };
    addEventListener('scroll', onScroll, { passive: true });
    setTimeout(() => { if (!shown && window.scrollY > 80) onScroll(); }, 1500);
  } else if (bar) bar.remove();

  $$('[data-privacy-choices]').forEach((a) => a.addEventListener('click', (e) => {
    if (p && p.saleOfDataRegion && p.saleOfDataRegion()) {
      e.preventDefault();
      p.setTrackingConsent({ sale_of_data: false }, () => toast((window.Theme && window.Theme.strings && window.Theme.strings.optedOut) || 'Noted. We will not sell or share your personal information.'));
    }
  }));
})();

document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-consent]'); if (!b) return;
  setConsent(b.dataset.consent === 'all');
});
